/**
 * Seed / ops markers must not surface as user-facing appointment notes.
 * StudioDemoLoadSeeder historically stored `demo-load:v1` in `notes`.
 */
export const isInternalAppointmentNote = (notes: string | null | undefined): boolean => {
  if (typeof notes !== "string") {
    return false;
  }
  const trimmed = notes.trim();
  if (trimmed === "") {
    return false;
  }
  return /^demo-load(?::|\b)/i.test(trimmed);
};

export const getDisplayableAppointmentNotes = (
  notes: string | null | undefined
): string | null => {
  if (typeof notes !== "string") {
    return null;
  }
  const trimmed = notes.trim();
  if (trimmed === "" || isInternalAppointmentNote(trimmed)) {
    return null;
  }
  return trimmed;
};
